export enum TotalUploadStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE_WITH_ERRORS = 'COMPLETE_WITH_ERRORS',
  COMPLETE_SUCCESS = 'COMPLETE_SUCCESS',
}
